"use client";

import dynamic from "next/dynamic";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useBoard } from "@/components/BoardProvider";

const PercentileGlobe = dynamic(
  () => import("@/app/percentile/components/PercentileDonut"),
  { ssr: false, loading: () => <div className="w-8 h-8 sm:w-10 sm:h-10" /> },
);

export function Logo() {
  const pathname = usePathname();
  const board = useBoard();
  const href = pathname?.startsWith("/dashboard") ? "/dashboard" : "/";

  const domain = board.domains[0] ?? `${board.slug}.fyi`;
  const dotAt = domain.indexOf(".");
  const domainName = dotAt === -1 ? domain : domain.slice(0, dotAt);
  const domainTld = dotAt === -1 ? "" : domain.slice(dotAt);

  return (
    <Link
      href={href}
      className="group flex items-center gap-2 sm:gap-3 cursor-pointer transition-opacity hover:opacity-80 motion-safe:active:scale-[0.97]"
    >
      <div className="w-8 h-8 sm:w-10 sm:h-10 transition-transform duration-200 ease-out motion-safe:group-hover:scale-105">
        <PercentileGlobe className="w-full h-full" speed={0.1} />
      </div>
      <span className="text-lg sm:text-xl font-bold text-foreground tracking-tight">
        {domainName}<span className="text-primary">{domainTld}</span>
      </span>
    </Link>
  );
} 